import React from 'react';
import { StarIcon, QuoteIcon } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    quote: "This wasn't just another conference. In 48 hours, I went from AI-curious to AI-confident. We built three working prototypes and left with a board-ready strategy. My team is already implementing what we learned.",
    author: 'Sarah Chen',
    role: 'VP of Product, Fortune 500 Tech Company',
    outcome: 'Launched AI pilot in 30 days',
    image: 'SC'
  }, {
    quote: "I've been to Stanford, Wharton, and countless executive programs. This was the most practical, high-impact learning experience of my career. The faculty aren't just academics—they're building real AI products.",
    author: 'Michael Rodriguez',
    role: 'Chief Strategy Officer, Healthcare',
    outcome: 'Saved 15 hours/week with AI workflows',
    image: 'MR'
  }, {
    quote: "Our entire leadership team attended. We left with a unified AI language, a 12-month roadmap, and actual prototypes we're now scaling. The ROI was immediate. Best investment we made this year.",
    author: 'Jennifer Park',
    role: 'CEO, Professional Services Firm',
    outcome: 'Aligned 8-person leadership team',
    image: 'JP'
  }, {
    quote: "I was skeptical about the 'bootcamp' format, but the intensity is what made it work. No distractions, world-class faculty, and peers who were as serious as I was. I left with clarity I couldn't get anywhere else.",
    author: 'David Okonkwo',
    role: 'Managing Director, Financial Services',
    outcome: 'Built AI governance framework',
    image: 'DO'
  }, {
    quote: "The Cancun setting wasn't just nice—it was strategic. Morning sessions were intense, afternoon recharge by the ocean, evening collaboration. I learned more in 48 hours than 6 months of webinars.",
    author: 'Lisa Thompson',
    role: 'Chief Innovation Officer, Manufacturing',
    outcome: 'Reduced decision-making time by 40%',
    image: 'LT'
  }, {
    quote: "What impressed me most was the caliber of other participants. CXOs from industries I'd never considered, all facing similar AI challenges. The peer learning alone was worth the investment.",
    author: 'James Wu',
    role: 'Founder & CEO, SaaS Startup',
    outcome: 'Raised Series B with AI strategy',
    image: 'JW'
  }];
  return <section className="py-24" data-id="element-368">
      <div className="max-w-7xl mx-auto px-6" data-id="element-369">
        <div className="text-center mb-16" data-id="element-370">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4" data-id="element-371">
            What Leaders Are Saying
          </h2>
          <p className="text-xl text-slate-400 max-w-3xl mx-auto" data-id="element-372">
            Real outcomes from real leaders who've completed the AI Leadership
            Hyper-Accelerator
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-373">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-slate-800/50 border border-slate-700 rounded-xl p-6 hover:border-cyan-500/50 transition-all duration-300" data-id="element-374">
              {/* Rating */}
              <div className="flex gap-1 mb-4" data-id="element-375">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-376" />)}
              </div>

              {/* Quote */}
              <div className="relative mb-6" data-id="element-377">
                <QuoteIcon className="absolute -top-2 -left-2 w-8 h-8 text-cyan-500/20" data-id="element-378" />
                <p className="text-slate-300 leading-relaxed pl-6" data-id="element-379">
                  "{testimonial.quote}"
                </p>
              </div>

              {/* Author */}
              <div className="flex items-center gap-4 pt-4 border-t border-slate-700" data-id="element-380">
                <div className="w-12 h-12 bg-gradient-to-br from-cyan-500 to-purple-500 rounded-full flex items-center justify-center text-white font-bold" data-id="element-381">
                  {testimonial.image}
                </div>
                <div className="flex-1" data-id="element-382">
                  <div className="font-semibold text-white" data-id="element-383">
                    {testimonial.author}
                  </div>
                  <div className="text-sm text-slate-400" data-id="element-384">
                    {testimonial.role}
                  </div>
                  <div className="text-xs text-cyan-400 mt-1" data-id="element-385">
                    ✓ {testimonial.outcome}
                  </div>
                </div>
              </div>
            </div>)}
        </div>

        {/* Trust statement */}
        <div className="mt-12 text-center" data-id="element-386">
          <p className="text-slate-400 text-lg" data-id="element-387">
            Join <span className="text-white font-semibold" data-id="element-388">500+ leaders</span>{' '}
            from <span className="text-white font-semibold" data-id="element-389">40+ countries</span>{' '}
            who've transformed their AI leadership
          </p>
        </div>
      </div>
    </section>;
}